<template>
    <div v-if="bizAuth.createHouseGroupAutomatically.hasRight" class="page-setting has-bc parent-frame batch-policy" :class="{'fixed': listIsFixed}">
        <div class="tool-bar-mask"></div>
        <div class="page-header">
            <h1>
                {{$route.meta.title}}({{listTotal}})
                <word-tips-hover data="相同地址、業務、屋主、完善的房源，才能建立同一個群組。" width="514px"></word-tips-hover>
            </h1>
            <!-- <div class="btn-group" v-if="hasSeletedHouse">
                <div class="default-button add-group" @click="setHouseGroup()">
                    加入群組
                </div>
            </div> -->
        </div>
        <div class="edit-house-group-name">
            <div class="house-group">
                <label class="button-font input-label">
                    <div class="title">
                        <span class="must-fill">*</span>
                        群組名稱
                    </div>
                    <span v-show="error.name" class="error-with-title">{{error.name}}</span>
                </label>
                <div class="input-arear">
                    <input :class="{error: error.name}" type="text" v-model="name" placeholder="請輸入群組名稱">
                </div>
            </div>
            <button class="default-button" @click="setHouseGroupName()">儲存名稱</button>
            <span class="address">地址：{{$route.query.address}}</span>
        </div>
        <edit-house-group-comp></edit-house-group-comp>
    </div>
</template>
<script>
import editHouseGroupComp from '@/components/bussiness/mgtCategory/houseGroupMgt/editHouseGroup/editHouseGroupComp.vue';
import wordTipsHover from '@/components/bussiness/widges/tips/wordTipsHover.vue';

import { mapGetters } from 'vuex'


export default {
    data () {
        return {
            listIsFixed: false,
            name: null,
            error: {
                name: null
            }
        }
    },
    mounted () {
        this.$analyticsBiz.logEvent(this.$route.meta.title, { screen_name: this.$route.meta.title})
        window.addEventListener('scroll', this.handleScroll);
    },
    destroyed() {
        window.removeEventListener('scroll', this.handleScroll);
        document.getElementsByClassName('biz-tool-bar-wrap')[0].style.display = 'flex'
    },
    watch: {
        $route: {
            handler: function (val){
                if(val.query.name){
                    this.name = val.query.name
                }
                this.$store.dispatch('setBizEditHouseGroupId', val.query.cid)
            },
            deep: true,
            immediate: true
        },
        'bizAuth.createHouseGroupAutomatically.hasRight': function (val) {
            if(!val){
                this.$store.dispatch('setModalStatus', {state: true, type: 'bizNoRight'})
            }
        },
        name: function (val){
            if(val){
                this.error.name = null
            }
        }
    },
    methods: {
        handleScroll: function () {
            let scrollTop = event.target.documentElement.scrollTop
            // console.log(scrollTop)
            if( scrollTop >= 50){
                document.getElementsByClassName('biz-tool-bar-wrap')[0].style.display = 'none'
                document.getElementsByClassName('page-header')[0].style.zIndex = '8'
            }else{
                document.getElementsByClassName('biz-tool-bar-wrap')[0].style.display = 'flex'
                document.getElementsByClassName('page-header')[0].style.zIndex = '8'
                this.listIsFixed = false
            }

            if( scrollTop >= 115){
                this.listIsFixed = true
            }
        },
        setHouseGroupName: function () {
            if(this.name){
                let obj = {
                    data: {
                        houseGroupId: this.$route.query.cid,
                        houseGroupName: this.name,
                        editType: 'NAME'
                    },
                    query: this.$route.query
                }
                this.$store.dispatch('editBizHouseGroup', obj )
                .then(()=>{
                    this.$store.dispatch('setAlarmStatus', {status: true,title: '群組名稱儲存成功',type: 'success'})
                    let newQuery = JSON.parse(JSON.stringify(obj.query)) // 深拷贝
                    newQuery.name = obj.data.houseGroupName
                    this.$router.replace({ query: newQuery })
                })
            }else{
                this.error.name = '請填寫群組名稱'
            }
        },
        setHouseGroup: function () {
            let obj = {
                data: {
                    houseGroupId: this.$route.query.cid,
                    editType: 'MULTIPLE'
                },
            }
            this.$store.dispatch('editBizHouseGroup', obj )
            .then(()=>{
                this.$store.dispatch('setAlarmStatus', {status: true,title: '加入群組成功',type: 'success'})
            })
           
        }
    },
    computed: {
        ...mapGetters({
            bizAuth: 'GET_BIZ_AUTH',
            listTotal: 'GET_BIZ_EDIT_HOUSE_GROUP_MGT_TOTAL',
            hasSeletedHouse: 'GET_BIZ_EDIT_HOUSE_GROUP_MGT_HAS_SELECTED_HOUSE'
        })
    },
    components: {
        editHouseGroupComp,
        wordTipsHover
    }
}
</script>
<style lang="scss" >
    .batch-policy{
        &.page-setting.fixed .table-list .table-list-title {
            width: 819px;
        }
        .add-group{
            width: 120px;
        }
        .edit-house-group-name{
            position: relative;
            display: flex;
            align-items: flex-end;
            border-radius: 6px;
            box-shadow: 1px 0 10px 0 rgba(41, 38, 37, 0.02);
            border: solid 1px #f3f3f3;
            background-color: #ffffff;
            padding: 24px;
            margin-bottom: 21px;
            
            .house-group{
                width: 424px;
                margin-right: 12px;
            }
            .default-button{
                width: 120px;
                height: 42px;
            }
            .address{
                position: absolute;
                right: 24px;
                bottom: 40px;
            }
        }
    }
</style>


// WEBPACK FOOTER //
// src/pages/bussiness/mgtCategory/houseGroupMgt/editHouseGroup.vue